<h2 mat-dialog-title *ngFor="let section of section_data">
    <a class="angle-left" *ngIf="flag==2">
        <i class="fa fa-angle-left fa-lg mr-3" (click)="flag=1;"></i>
    </a>
    {{section.section_title}}
    <a (click)="onCancel()" *ngIf="flag==1">
        <i class="fa fa-times pointer pt-2 pr-3 float-right"></i>
    </a>
</h2>
<mat-dialog-content>
    <div class="pt-2">
        <tm-dynamic-form *ngIf="masters && section_data && flag==1" [section_list]="section_data" [masters]="masters" [display_type]="display_type"
            [dynamic_form]="dynamic_form" [parentCellClicked]="CellClicked" [callback_func]="callbackFuncRef">
        </tm-dynamic-form>
        <div class="row" *ngIf="flag==2">
            <div class="col-md-12 col-sm-12 pt-1 pb-1">
                <div class="row form-group" *ngIf="value">
                    <div class="col-md-12">
                        <div class="card p-3" style="border: 0.5px solid gainsboro;
                            margin-bottom: 10px;border-radius:5px !important">
                            <p>{{description}}</p>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <p (click)="termsConditions()" class="terms">
                            <input id="field_terms" type="checkbox" [(ngModel)]="terms_conditions" [ngModelOptions]="{standalone: true}" name="terms"> I accept the
                            <u>Terms and Conditions
                            </u>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row mt-1" *ngFor="let section of section_data">
        <div class="col-md-12" *ngIf="flag==1">
            <button class="float-right ml-1 btn btn-sm btn-primary" (click)="flagSecond(dynamic_form.get([section_data[0].section_id]))">
                {{'21_9973_9899_1036' | translate}}
            </button>
        </div>
        <div class="col-md-12" *ngIf="flag==2">
            <button class="btn btn-sm btn-light mt-2 float-left" (click)="flag=1">
                {{'21_9973_9899_1037' | translate}}
            </button>
            <button [disabled]="loading" class="float-right  ml-1 mt-2 btn btn-sm btn-primary" (click)="dynamicFormSave(section, section.multiple ? section.multiple_form : dynamic_form.get([section.section_id]))">
                <div *ngIf="loading" style="text-align: center;">
                    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                </div>
                <span *ngIf="!loading">
                    {{'21_9973_9899_1038' | translate}}
                </span>
            </button>
            <button class="float-right ml-auto mt-2 btn btn-sm btn-danger" (click)="cancel()">
                {{'21_9973_9899_1039' | translate}}
            </button>

        </div>
    </div>
</mat-dialog-actions>